import Vue from 'vue'
import store from '@/configuracoes/stores'
import cHttp from '@/aplicacao/_constantes/Http'
import sStores from '@/aplicacao/_servicos/stores'
import EventBusGlobal from '@/aplicacao/_eventos/global'

export default {

    logarServer(email, senha, la) {

        return new Promise((resolver, rejeitar) => {

            Vue.http.post('autenticacao/login', { email, senha, la })
                .then(res => res.json())
                .then(
                    res => {

                        resolver(res.dados)

                    },
                    err => {

                        if (
                            (cHttp.BAD_REQUEST === err.data.codigo) ||
                            (cHttp.UNAUTHORIZED === err.data.codigo)
                        ) {
                            if (err.data.erro) {
                                rejeitar(err.data.erros[0])
                            }
                        }

                    }
                )

        })

    },

    logarClient(dados, lembrar) {

        if (lembrar) {
            this.loginLembrarSalvar(dados.usuario)
        } else {
            this.loginLembrarRemover()
        }

        this.refreshClient(dados)

        if (store.state['sessao'].permissoes.includes('ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_SOLICITAR')) {
            localStorage.setItem('abrir-lightbox-vendas-whats-midias', true)
        }

        if (dados.usuario.email === 'bancodemidias@tradefriboi.com.br') {
            Vue.router.push({ name: 'banco-de-midias' })
            return
        }

        let redirect = Vue.router.currentRoute.query.redirect
        let route = redirect ? redirect : { name: process.env.VUE_APP_ROTA_INICIAL }
        let permissaoComunicados = store.state['sessao'].permissoes.includes('ROLE_COMUNICADOS_RECEBER')

        if (dados.expiracao.expiracaoHabilitada && dados.expiracao.senhaExpirada) {

            let name = process.env.VUE_APP_ROTA_SENHA_EXPIRADA
            route = redirect ? { name, query: { redirect } } : { name }
            Vue.router.push(route).catch(() => {})

        } else if (permissaoComunicados) {

            Vue.http.get(`comunicados/cabecalhos/destinatario/${dados.usuario.id}/nao-lidos`)
                .then(res => res.json())
                .then(res => {

                    let temComunicadosNaoLidos = 0 < res.dados.cabecalhos.length

                    if (temComunicadosNaoLidos) {
                        localStorage.setItem('comunicados', true)
                        let name = process.env.VUE_APP_ROTA_COMUNICADOS_DASHBOARD
                        route = redirect ? { name, query: { redirect } } : { name }
                    }

                    Vue.router.push(route).catch(() => {})

                })

        } else {

            Vue.router.push(route).catch(() => {})

        }

    },

    deslogarServer() {

        return Vue.http.post('autenticacao/logout')
            .then(res => {}, err => {})

    },

    deslogarClient(redirect) {

        localStorage.removeItem('token')
        sStores.resetarTodasStores()

        if (
            ('autenticacao-login' !== Vue.router.currentRoute.name) &&
            ('autenticacao-esqueci-minha-senha-iniciar' !== Vue.router.currentRoute.name)
        ) {
            Vue.router.push({ name: 'autenticacao-login' }).catch(() => {})
        }

    },

    deslogarCompleto() {

        if (localStorage.getItem('comunicados')) {
            localStorage.removeItem('comunicados')
        }

        if (localStorage.getItem('token')) {
            this.deslogarServer()
        }

        this.deslogarClient()

    },

    refreshServer() {

        return new Promise((resolver, rejeitar) => {
            Vue.http.post('autenticacao/refresh')
                .then(res => res.json())
                .then(
                    res => {
                        resolver(res.dados)
                    },
                    err => {
                        if (cHttp.UNAUTHORIZED === err.data.codigo) {
                            rejeitar()
                        }
                    }
                )
        })

    },

    refreshClient(dados) {

        sStores.resetarStore('sessao')

        localStorage.setItem('token', dados.token)

        store.dispatch('sessao/setUsuario', dados.usuario)
        store.dispatch('sessao/setPermissoes', dados.permissoes)
        store.dispatch('sessao/setPreferencias', dados.preferencias)
        store.dispatch('sessao/setPerfil', dados.perfil)
        store.dispatch('sessao/setExpiracao', dados.expiracao)

        store.dispatch('pendencias/setPendencias', dados.pendencias)
        EventBusGlobal.$emit('refresh')

        if (localStorage.hasOwnProperty('utilitarios')) {
            if ('true' === localStorage.getItem('utilitarios')) {
                store.dispatch('utilitarios/abrir')
            } else {
                store.dispatch('utilitarios/fechar')
            }
        }

        if (localStorage.hasOwnProperty('abrir-lightbox-vendas-whats-midias')) {
            if ('true' === localStorage.getItem('abrir-lightbox-vendas-whats-midias')) {
                store.dispatch('lightbox/abrir', require('@/aplicacao/_assets/imagens/vendas-whats-midias.jpg'))
                localStorage.removeItem('abrir-lightbox-vendas-whats-midias')
            }
        }

        if (dados.expiracao.expiracaoHabilitada && dados.expiracao.senhaExpirada && (process.env.VUE_APP_ROTA_SENHA_EXPIRADA !== Vue.router.currentRoute.name)) {
            let redirect = Vue.router.currentRoute.query.redirect
            let name = process.env.VUE_APP_ROTA_SENHA_EXPIRADA
            let route = redirect ? { name, query: { redirect } } : { name }
            Vue.router.push(route).catch(() => {})
        }

    },

    verificarSessao() {

        if (localStorage.getItem('token')) {

            this.refreshServer()

                .then(dados => {

                    this.refreshClient(dados)

                    if ('development' !== process.env.NODE_ENV) {
                        setTimeout(() => {
                            this.verificarSessao()
                        }, parseInt(process.env.VUE_APP_REFRESH_DELAY))
                    }

                })

                .catch(() => {
                    this.deslogarClient()
                })

        } else {

            this.deslogarClient()

        }

    },

    loginLembrarObter() {

        if (localStorage.getItem('loginLembrar')) {
            return {
                email: localStorage.getItem('loginLembrarEmail'),
            }
        }

        return null

    },

    loginLembrarSalvar(usuario) {
        localStorage.setItem('loginLembrar', true)
        localStorage.setItem('loginLembrarEmail', usuario.email)
    },

    loginLembrarRemover() {
        localStorage.removeItem('loginLembrar')
        localStorage.removeItem('loginLembrarEmail')
    },

}
